function syncPopupScale() {
  const scale = Math.min(1, window.innerWidth / 1200, window.innerHeight / 676);
  document.documentElement.style.setProperty('--popup-login-scale', scale.toFixed(4));
  document.querySelectorAll('.MS__popup .box').forEach((box) => {
    box.style.setProperty('--popup-scale', scale.toFixed(4));
  });
}

window.addEventListener('load', function () {
  syncPopupScale();

  document.querySelectorAll('.MJ__close-popup').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const popup = button.closest('.MS__popup');
      if (popup) popup.classList.remove('active');
    });
  });
});

window.addEventListener('resize', syncPopupScale, { passive: true });
